<template>
  
  <BethsLayout :layoutTitle="`Privacy Policy`" :hasBuilding="false">
    <h1>SafetyNet Privacy Policy</h1>

    <ol class="list-decimal p-4">
      <li class="my-4">
        <u><strong>What information do we collect? </strong></u><br />
        We collect information from you when you sign up on our site, log in, take
        training, and complete tests. Collected information includes but is not limited to
        your name, email address, phone number, the floor you work on, your tenant or
        departmental affiliation, the emergency response role you play at your facility,
        the training module you are seeking, the tests you take, and your test scores.
        <br />
      </li>
      <li class="my-4">
        <u><strong>Product. </strong></u><br />
        Each Product includes computer software and any associated video, media, printed
        materials, plans, diagrams, brochures or other related products including “online”
        or electronic materials, and any reference to the term Product shall include such
        items.
        <br />
        In addition, when you visit a SafetyNet site, some basic information may be
        collected by our Web servers (automatically sent to us by your Web browser). This
        information will be used solely to help us make this site more useful to visitors,
        and to learn about the number of visitors to our site and the types of technology
        they use. All of this helps us ensure that this site is as useful as possible.
        This basic information that may be collected is:
        <ul class="list-disc pl-8">
          <li>The Internet domain and IP address from which you accessed our site;</li>
          <li>The type of browser and operating system used to access our site;</li>
          <li>The date and time you accessed our site;</li>
          <li>The specific pages you visited; and</li>
          <li>
            If you linked to the SafetyNet site from another Web site, the address and
            other information for that Web site.
          </li>
        </ul>
      </li>
      <li class="my-4">
        <u><strong>What do we use your information for?</strong></u
        ><br />
        The information we collect from you may be used:
        <ol class="list-decimal pl-8">
          <li>
            To provide the appropriate service (access to the right training programs and
            documents, response steps, emergency alerts, etc.).
          </li>
          <li>To notify you when training is due</li>
          <li>
            To allow your employer, building management, or sponsoring organization to
            communicate with you regarding emergency preparedness and related topics that
            could affect you or your organization
          </li>
          <li>
            To provide your employer, building management, or sponsoring organization with
            information on training activity and site utilization. This includes
            individual training records.
          </li>
          <li>To improve the SafetyNet service</li>
          <li>
            To inform you of any upgrades, service interruptions, or other important
            notices about the SafetyNet service
          </li>
        </ol>
      </li>
      <li class="my-4">
        <u><strong>Who owns your content?</strong></u
        ><br />
        AK Productions LLC (AK), the provider of the SafetyNet service, retains ownership
        of all data collected via this service, with the exception of any documents you
        may post to your SafetyNet site.
      </li>
      <li class="my-4">
        <u><strong>Do we disclose any information to outside parties?</strong></u>
        We do not sell, trade, share, or otherwise transfer data to outside parties. This
        does not include trusted third parties who assist us in operating our website,
        conducting our business, or servicing you, so long as those parties agree to keep
        this information confidential. We may also release your information to comply with
        the law, enforce our site policies, or protect ours or others’ rights, property,
        or safety.
      </li>
      <li class="my-4">
        <u><strong>Who has access to your data?</strong></u
        ><br />
        Access to your data is limited to:
        <ol class="list-decimal pl-8">
          <li>Yourself</li>
          <li>AK staff who support the SafetyNet service</li>
          <li>Your employer, property manager, and/or sponsoring organization</li>
          <li>
            Service Providers: We use other companies, agents or contractors ("Service
            Providers") to perform services on our behalf or to assist us with the
            provision of services to you. For example, we engage Service Providers,
            including Amazon Web Services to provide communications, infrastructure and IT
            services. In the course of providing such services, these Service Providers
            may have access to your personal or other information. We do not authorize
            them to use or disclose your personal information except in connection with
            providing their services.
          </li>
        </ol>
      </li>
      <li class="my-4">
        <u><strong>Do we use cookies?</strong></u
        ><br />
        Cookies are small files that a site or its service provider transfers to your
        computer’s hard drive through your Web browser that enables the sites or service
        providers systems to recognize your browser and capture and remember certain
        information. SafetyNet uses cookies to remember your user name in order to speed
        logging and save your preferences for future visits. You need to have cookies
        enabled to be able to log in to the service.
      </li>

      <li class="my-4">
        <u><strong>Terms of Use</strong></u
        ><br />
        Please also visit our Terms of Use establishing the use, disclaimers, and
        limitations of liability governing the use of our website.
      </li>

      <li class="my-4">
        <u><strong>Your consent</strong></u
        ><br />
        By using our site, you consent to our privacy policy. If you do not agree to the
        terms of this Privacy Policy, please do not use the Sites. We reserve the right to
        modify or amend the terms of our Privacy Policy from time to time without notice.
        Your continued use of our Sites following the posting of changes to these terms
        will mean you accept those changes.
      </li>

      <li class="my-4">
        <u><strong>Changes to our privacy policy</strong></u
        ><br />
        If we decide to change our privacy policy, we will post those changes on this
        page.
      </li>
      <li class="my-4">
        <u><strong>Children’s Online Privacy Protection Act Compliance</strong></u>
        We do not collect any information from anyone under 13 years of age. Our website,
        products and services are all directed to people who are at least 13 years old or
        older.
      </li>
      <li class="my-4">
        <u><strong>Assignment</strong></u
        ><br />
        We may change our ownership or corporate organization while providing the Sites
        and services. We may also sell certain assets associated with the Sites. As a
        result, please be aware that in such event we may transfer some or all of your
        information to a company acquiring all or part of our assets or to another company
        with which we have merged. Under such circumstances we would, to the extent
        possible, require the acquiring party to follow the practices described in this
        Privacy Policy, as it may be amended from time to time. Nevertheless, we cannot
        promise that an acquiring company or the merged company will have the same privacy
        practices or treat your information the same as described in this Privacy Policy.
      </li>

      <li class="my-4">
        <u><strong>Contacting information</strong></u
        ><br />
        If there are any questions regarding this privacy policy, you may contact us on
        <a href="mailto:info@akpreparedness.com">info@akpreparedness.com</a>
      </li>
    </ol>
  </BethsLayout>
</template>
